    import React, { useState, useEffect } from 'react';
    import DataTable from 'react-data-table-component';
    import { Box, Typography, FormControl, Select, MenuItem, TextField, FormControlLabel, CircularProgress } from '@mui/material';
    import { Edit, Delete } from '@mui/icons-material';
    import { Switch, styled } from '@mui/material';
    import { toast } from 'react-toastify';
    import { useNavigate } from 'react-router-dom';
    import userimg from '../../../assets/images/user_img.png';
    import VisibilityIcon from '@mui/icons-material/Visibility';
    import axios from 'axios'; 
    import { fetchDrivers } from '../../../redux/slices/DriverSlice';
    import { useDispatch, useSelector } from "react-redux";

    const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
            backgroundColor: 'green',
            opacity: 1,
            border: 0,
        },
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: 'red',
        opacity: 1,
    },
    }));

    const   MyTable = () => {
    const [data, setData] = useState([]);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
        
    
        useEffect(() => {
        dispatch(fetchDrivers());
        }, [dispatch]);
        // Update data when alldrivers changes
        const { alldrivers, loading, error } = useSelector((state) => state.getdrivers);
    console.log(alldrivers)
    const formattedData = alldrivers?.drivers?.map((driver, index) => ({
        id: driver._id || index,
        image: driver.profileImage || userimg, // Use default image if none exists
        UserName: driver.name || "N/A",
        email: driver.email || "N/A",
        phone: driver.phone || "N/A",
        date: driver.createdAt ? new Date(driver.createdAt).toLocaleDateString() : "N/A",
        active: driver.active || false,
        totalOrders: driver.orderCount || 0,
    })) || [];
    useEffect(() => {
        if (alldrivers?.drivers) {
          setData(formattedData);
        }
      }, [alldrivers]); 


    const handleSelectAll = () => {
        if (selectAll) {
        setSelectedRows([]);
        } else {
        const allIds = data.map(item => item.id);
        setSelectedRows(allIds);
        }
        setSelectAll(!selectAll);
    };

    const handleRowCheckboxChange = (rowId) => {
        if (selectedRows.includes(rowId)) {
        setSelectedRows(selectedRows.filter(id => id !== rowId));
        } else {
        setSelectedRows([...selectedRows, rowId]);
        }
    };

    const deleteItem = (itemId) => {
        alert('User has been Deleted');
    };
    const maskEmail = (email) => {
        const [localPart, domain] = email.split('@');
        const maskedLocalPart = localPart.slice(0, 2) + '****' + localPart.slice(localPart.length - 2);
        return `${maskedLocalPart}@${domain}`;
    };
    
    const maskPhoneNumber = (phone) => {
        return phone.slice(0, 3) + '****' + phone.slice(7);
    };
    const columns = [
        {
        name: (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} checked={selectAll} onChange={handleSelectAll}>
            <Box>
                <input type="checkbox" />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', color: 'green' }}>
                <Delete
                sx={{
                    cursor: 'pointer',
                    padding: '0px',
                    fontSize: '18px',
                }}
                onClick={() => alert('Delete all items action triggered!')}
                />
                <Typography variant="body1">All</Typography>
            </Box>
            </Box>
        ),
        selector: row => row.id,
        cell: (row) => (
            <input type="checkbox" checked={selectedRows.includes(row.id)} 
            onChange={() => handleRowCheckboxChange(row.id)} />
        ),
        sortable: false,
        style: {
            padding: '8px',
            textAlign: 'center',
        },
        },
        {
        name: 'Images',
        selector: row => row.image,
        cell: row => (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
                src={row.image}
                alt={row.UserName}
                style={{ width: 50, height: 50, objectFit: 'cover', marginRight: 8 }}
            />
            </Box>
        ),
        sortable: false,
        style: {
            padding: '8px',
        },
        },
        {
        name: 'Name',
        selector: row => row.UserName,
        sortable: true,
        style: {
            padding: '8px',
        },
        },
        {
        name: 'Email',
        selector: row => row.email,
        cell: row => maskEmail(row.email), // Apply email masking
        sortable: true,
        style: {
            padding: '8px',
        },
        },
        {
        name: 'Date',
        selector: row => row.date,
        sortable: true,
        style: {
            padding: '8px',
        },
        },
        {
        name: 'Active',
        selector: row => row.active,
        cell: row => (
            <FormControlLabel
            control={
                <IOSSwitch
                checked={row.active}
                onChange={() => {
                    const updatedData = data.map(item =>
                    item.id === row.id ? { ...item, active: !item.active } : item
                    );
                    setData(updatedData);
                }}
                />
            }
            />
        ),
        sortable: false,
        style: {
            padding: '8px',
        },
        },
        {
        name: 'Total Orders',
        selector: row => row.totalOrders,
        sortable: true,
        cell: row => (
            <Typography
            variant="body1"
            sx={{ color: 'green', fontWeight: '400' }} // Add green color styling
            >
            {row.totalOrders}
            </Typography>
        ),
        style: {
            padding: '8px',
        },
        },
        {
        name: 'Actions',
        cell: row => (
            <Box sx={{ display: 'flex', gap: {xs:'4px',lg:2} }}>
            <VisibilityIcon sx={{
                cursor: 'pointer',
                backgroundColor: '#E1E7E9',
                color: '#000',
                borderRadius: '50%',
                padding: '5px',
                fontSize: '28px',
                }}
                onClick={() => navigate(`view/${row.id}`)}/>
            <Edit
                sx={{
                cursor: 'pointer',
                backgroundColor: 'green',
                color: '#fff',
                borderRadius: '50%',
                padding: '5px',
                fontSize: '28px',
                }}
                onClick={() => navigate(`edit/${row.id}`)}
            />
            <Delete
                sx={{
                cursor: 'pointer',
                backgroundColor: 'red',
                color: '#fff',
                borderRadius: '50%',
                padding: '6px',
                fontSize: '28px',
                }}
                onClick={() => deleteItem(row.id)}
            />
            </Box>
        ),
        sortable: false,
        style: {
            padding: '8px',
        },
        },
    ];

    const filteredData = data.filter(item =>
        (item.id.toString().includes(searchTerm) ||
        (item.UserName && item.UserName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.email && item.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.phone && item.phone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.date && item.date.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.active.toString().includes(searchTerm)) ||
        (item.totalOrders.toString().includes(searchTerm))
        )
    );

    const startIndex = (page - 1) * entriesPerPage;
    const currentPageData = filteredData.slice(startIndex, startIndex + entriesPerPage);

    const handleEntriesChange = event => {
        setEntriesPerPage(event.target.value);
        setPage(1); // Reset page to 1 when changing entries per page
    };

    const handleSearchChange = event => {
        setSearchTerm(event.target.value);
    };

    return (
        <div>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px',flexWrap: { xs: 'wrap', md: 'nowrap' } }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1" sx={{ mr: 1 }}>
                Show
            </Typography>
            <FormControl sx={{ p: 1 }}>
                <Select
                value={entriesPerPage}
                onChange={handleEntriesChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Entries per page' }}
                >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
                </Select>
            </FormControl>
            <Typography variant="body1" sx={{ mr: 1 }}>
                entries
            </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1" sx={{ mr: 1 }}>
                Search:
            </Typography>
            <TextField
                className="recent-or-search-cls"
                id="outlined-basic"
                label=""
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
                size="small"
            />
            </Box>
        </Box>

        <Box sx={{ border: '1px solid #dee2e6', borderRadius: '8px', overflow: 'hidden' }}>
            {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                        <CircularProgress />
                        <Typography variant="body1" sx={{ marginLeft: 2 }}>Drivers loading...</Typography>
                    </Box>
                    ) : (
            <DataTable
            columns={columns}
            data={currentPageData}
            pagination
            paginationServer
            paginationTotalRows={filteredData.length}
            onChangePage={newPage => setPage(newPage)}
            paginationPerPage={entriesPerPage}
            paginationComponentOptions={{
                noRowsPerPage: true, // Disables rows per page dropdown
            }}
            customStyles={{
                table: {
                style: {
                    tableLayout: 'auto',
                },
                },
                cells: {
                style: {
                    padding: '8px',
                    border: '1px solid #dee2e6',
                    color: '#67757c',
                    fontSize: '14px',
                },
                },
                headCells: {
                style: {
                    backgroundColor: '#f4f4f4',
                    fontWeight: 'bold',
                    padding: '8px',
                    border: '1px solid #dee2e6',
                    fontSize: '1rem',
                },
                },
                rows: {
                style: {
                    '&:hover': {
                    backgroundColor: '#f1f1f1',
                    },
                    '&:nth-child(odd)': {
                    boxShadow: 'inset 0 0 0 9999px rgba(0, 0, 0, 0.023)',
                    },
                },
                },
            }}
            />
                    )}
        </Box>
        </div>
    );
    };

    export default MyTable;
